<template>
  <div class="home min-container">
    <div v-if="showBanner" class="banner min-container">
      <swiper ref="swiperBanner" :options="swiperBannerOption">
        <swiper-slide
          v-for="(item, index) in banner"
          :key="index"
          class="slider-img"
        >
          <template v-if="item.type === 0">
            <a
              v-if="item.link"
              :style="item.style"
              class="banner_img"
              aria-label="banner_img"
              :href="item.link"
              target="_blank"
            />
            <a
              v-else
              :style="item.style"
              class="banner_img"
              aria-label="banner_img"
            />
          </template>
          <div
            style="position: relative; width: 100%; height: 100%"
            @mouseenter="play_show = true"
            @mouseleave="play_show = false"
          >
            <div
              v-if="no_video_play"
              class="video_play"
              @click.prevent="toPlay($event)"
            >
              <img
                class="circle"
                src="/official/static/img/home/circle.png"
                alt
              />
            </div>
            <div
              v-if="play_show && !no_video_play"
              class="video_pause"
              @click.prevent="toPause()"
            >
              <img
                class="circle"
                src="/official/static/img/home/circle.png"
                alt
              />
            </div>

            <video
              v-if="item.type === 1"
              id="player"
              ref="video"
              loop
              style="
                object-fit: cover;
                position: absolute;
                width: 100%;
                height: 100%;
              "
            >
              <source :src="item.video" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </swiper-slide>
        <div
          v-if="banner.length > 1"
          slot="pagination"
          class="swiper-pagination"
        />
        <div
          v-if="banner.length > 1"
          slot="button-prev"
          class="swiper-button-prev"
        />
        <div
          v-if="banner.length > 1"
          slot="button-next"
          class="swiper-button-next"
        />
      </swiper>
    </div>
    <div class="top min-container">
      <div class="t_download">
        <a
          id="fbAndroidDL"
          aria-label
          target="_blank"
          :href="FB_VERSON"
          @click="
            toBury(
              'officialwebsite_pc_homepage_download_android',
              1009,
              1,
              0,
              0,
              9
            )
          "
        >
          <img src="/official/static/img/home/download_04.png" alt />
        </a>
        <a
          id="appstoreDL"
          target="_blank"
          aria-label
          :href="appStoreLink"
          @click="
            toBury(
              'officialwebsite_pc_homepage_download_appstore',
              1009,
              1,
              0,
              0,
              10
            )
          "
        >
          <img src="/official/static/img/home/download_02.png" alt />
        </a>
        <a
          id="googleplayDl"
          target="_blank"
          aria-label
          href="https://play.google.com/store/apps/details?id=com.lein.pppoker.android"
          @click="
            toBury(
              'officialwebsite_pc_homepage_download_googleplay',
              1009,
              1,
              0,
              0,
              11
            )
          "
        >
          <img src="/official/static/img/home/download_01.png" alt />
        </a>
        <a
          id="windowsDL"
          target="_blank"
          aria-label
          :href="PC_VERSON"
          @click="
            toBury(
              'officialwebsite_pc_homepage_download_windows',
              1009,
              1,
              0,
              0,
              12
            )
          "
        >
          <img src="/official/static/img/home/download_03.png" alt />
        </a>
      </div>
      <div class="container tab_title">
        <div class="tab_li">
          <div
            v-for="item in tabs"
            :key="item.id"
            :class="{ hightab: item.id == tabId }"
            @mouseenter="tabId = item.id"
          >
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="top_tab">
        <div class="tab-image">
          <div
            v-for="(item, index) in formatData(tabLists[tabId], 0, 1)"
            :key="index"
            class="jumpUrl"
          >
            <img
              width="100%"
              height="385px"
              :src="item.pcImage"
              class="image"
              alt
              @click="toOpen(item.jumpUrl)"
            />
            <div class="jump_cont">
              <p class="jump_p" @click="toOpen(item.jumpUrl)">
                {{ item.title }}
              </p>
              <div class="jump_release">
                <span>{{ item.release_date }}</span>
                <img
                  v-if="item.from_channel"
                  height="38px"
                  :src="
                    '/official/static/img/home/channel/' +
                    item.from_channel +
                    '.png'
                  "
                  alt
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="showtab" class="tab_cont">
          <div class="tab_p">
            <div
              v-for="(item, index) in formatData(tabLists[tabId], 1, 6)"
              :key="index"
              class="jumpUrl"
              :class="{ highlight: item.id === newId }"
            >
              <img
                :src="item.pcImage"
                width="157px"
                height="90px"
                class="image"
                alt
                @click="toOpen(item.jumpUrl)"
              />
              <div class="jump_cont">
                <p class="jump_p" @click="toOpen(item.jumpUrl)">
                  {{ item.title }}
                </p>
                <div class="jump_release">
                  <span>{{ item.release_date }}</span>
                  <img
                    v-if="item.from_channel"
                    height="25px"
                    :src="
                      '/official/static/img/home/channel/' +
                      item.from_channel +
                      '.png'
                    "
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bottom_container">
        <div class="container">
          <div class="join_title">
            <div>{{ $t("common.p113") }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="middle min-container">
      <h2 class="center">
        {{ $t('common.p36') }}
      </h2>
      <swiper :options="swiperOption">
        <swiper-slide
          v-for="item in playLists"
          :key="item.id"
        >
          <a
            class="m-slide-image"
            :href="item.jumpUrl"
            target="_blank"
          >
            <img
              :src="item.pcImage"
              alt
            >
            <div class="image-bottom">
              <p>{{ item.name }}</p>
            </div>
          </a>
        </swiper-slide>
      </swiper>
      <div class="middle_icon">
        <span>#PPPoker</span>
        <a
          target="_blank"
          href="https://www.facebook.com/pppoker123"
          class="facebook-img"
        />
        <a
          target="_blank"
          href="https://www.instagram.com/pppokerglobal"
          class="instagram-img"
        />
        <a
          target="_blank"
          href="https://www.youtube.com/channel/UCpklAxJQBUEoFISwCn9o4jg?view_as=subscriber"
          class="youtube-img"
        />
        <a
          target="_blank"
          href="https://twitter.com/pppokerofficial"
          class="twitter-img"
        />
      </div>
    </div> -->

    <div class="club">
      <div class="min-container club_bg1">
        <div class="container">
          <div class="club_item">
            <div class="club_item_l">
              <h2 class="title">
                {{ $t("common.p40") }}
              </h2>
              <h2 class="c_p_title">
                {{ $t("common.p41") }}
              </h2>
              <div class="more">
                <a target="_blank" href="/blog/12" aria-label>{{
                  $t("common.p37")
                }}</a>
              </div>
            </div>
            <div class="club_item_r">
              <a
                target="_blank"
                aria-label
                href="/blog/12"
                style="display: block"
              >
                <div v-show="showAnimal1" class="animal1" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="min-container club_bg2">
        <div class="container">
          <div class="club_item">
            <div class="club_item_l">
              <a
                target="_blank"
                href="/blog/15"
                aria-label
                style="display: block"
              >
                <div v-show="showAnimal2" class="animal2" />
              </a>
            </div>
            <div class="club_item_r">
              <h2 class="title">
                {{ $t("common.p44") }}
              </h2>
              <h2 class="c_p_title">
                {{ $t("common.p45") }}
              </h2>
              <div class="more">
                <a target="_blank" href="/blog/15" aria-label>{{
                  $t("common.p37")
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="min-container club_bg3">
        <div class="container">
          <div class="club_item">
            <div class="club_item_l">
              <h2 class="title">
                {{ $t("common.p48") }}
              </h2>
              <h2 class="c_p_title">
                {{ $t("common.p49") }}
              </h2>
              <div class="more">
                <a target="_blank" href="/blog/14" aria-label>{{
                  $t("common.p37")
                }}</a>
              </div>
            </div>
            <div class="club_item_r">
              <a
                target="_blank"
                aria-label
                href="/blog/14"
                style="display: block"
              >
                <div v-show="showAnimal3" class="animal3" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="min-container club_bg4">
        <div class="container">
          <div class="club_item">
            <div class="club_item_l">
              <a
                target="_blank"
                href="/blog/18"
                aria-label
                style="display: block"
              >
                <div v-show="showAnimal4" class="animal4" />
              </a>
            </div>
            <div class="club_item_r">
              <h2 class="title">
                {{ $t("common.p53") }}
              </h2>
              <h2 class="c_p_title">
                {{ $t("common.p54") }}
              </h2>
              <div class="more">
                <a target="_blank" aria-label href="/blog/18">{{
                  $t("common.p37")
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="min-container club_bg5">
        <div class="container">
          <div class="club_item">
            <div class="club_item_l">
              <h2 class="title">
                {{ $t("common.p85") }}
              </h2>
              <h2 class="c_p_title">
                {{ $t("common.p86") }}
              </h2>
              <div class="more">
                <a target="_blank" href="/blog/16" aria-label>{{
                  $t("common.p37")
                }}</a>
              </div>
            </div>
            <div class="club_item_r">
              <a
                target="_blank"
                href="/blog/16"
                aria-label
                style="display: block"
              >
                <div v-show="showAnimal5" class="animal5" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="min-container club_bg6">
        <div class="container">
          <div class="club_item">
            <div class="club_item_l">
              <a
                target="_blank"
                href="/blog/17"
                aria-label
                style="display: block"
              >
                <div v-show="showAnimal6" class="animal6" />
              </a>
            </div>
            <div class="club_item_r">
              <h2 class="title">
                {{ $t("common.p90") }}
              </h2>

              <h2 class="c_p_title">
                {{ $t("common.p91") }}
              </h2>
              <div class="more">
                <a target="_blank" href="/blog/17" aria-label>{{
                  $t("common.p37")
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="float_button">
      <a
        target="_blank"
        href="https://www.instagram.com/pppokerglobal"
        class="instagram-img"
      />
      <a
        target="_blank"
        href="https://www.youtube.com/channel/UCpklAxJQBUEoFISwCn9o4jg?view_as=subscriber"
        class="youtube-img"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {
  getBanner,
  getNewsTabList,
  getNewsList,
  getSocialList,
  getIp,
} from "@/api/official";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      banner: [],
      tabs: [],
      tabId: "",
      tabLists: {},
      pcImage: "",
      pcJumpUrl: "",
      newId: "",
      playLists: [],
      swiperBannerOption: {
        // loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
        on: {
          slideChange: () => {
            // this.swiper.update()
            if (!this.no_video_play) {
              this.toPause();
            }
          },
        },
        pagination: {
          clickable: true,
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      showBanner: true,
      swiperOption: {
        // loop: true,
        slidesPerView: "auto",
        slidesPerColumn: 2,
        spaceBetween: 0,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      no_video_play: true,
      play_show: false,
      PC_VERSON: "",
      FB_VERSON: "",
      showtab: false,
      showAnimal1: false,
      showAnimal2: false,
      showAnimal3: false,
      showAnimal4: false,
      showAnimal5: false,
      showAnimal6: false,
      appStoreLink:
        "https://apps.apple.com/in/app/pppoker-nlh-plo-ofc/id1101622978",
    };
  },
  computed: {
    swiper() {
      return this.$refs.swiperBanner.swiper;
    },
  },
  created() {
    this.$store.commit("changeTab", "/home");
    this.initData();
    // eslint-disable-next-line no-undef
    this.PC_VERSON = PC_VERSON || "";
    // eslint-disable-next-line no-undef
    this.FB_VERSON = FB_VERSON;
  },
  mounted() {
    document
      .querySelector("#app")
      .scrollIntoView({ block: "start", behavior: "smooth" });

    window.addEventListener("scroll", () => {
      let scrollt =
        document.documentElement.scrollTop + document.body.scrollTop;
      if (scrollt > 1200) {
        this.showAnimal1 = true;
      }
      if (scrollt > 2000) {
        this.showAnimal2 = true;
      }
      if (scrollt > 2800) {
        this.showAnimal3 = true;
      }
      if (scrollt > 3600) {
        this.showAnimal4 = true;
      }
      if (scrollt > 4400) {
        this.showAnimal5 = true;
      }
      if (scrollt > 5200) {
        this.showAnimal6 = true;
      }
    });
  },
  methods: {
    toOpen(url) {
      window.open(url);
    },
    formatData(data, left, right) {
      if (data && data.length) {
        return data.slice(left, right);
      }
      return [];
    },
    initData() {
      getBanner()
        .then((res) => {
          this.banner = res.data.list
            .filter((v) => {
              return v.image[this.$i18n.locale] || v.type === 1;
            })
            .map((v) => {
              return {
                style: {
                  backgroundImage:
                    v.type === 0
                      ? "url(" + v.image[this.$i18n.locale].pc + ")"
                      : "",
                },
                link: v.jumpUrl,
                type: v.type,
                video: v.type === 1 ? v.video.pc : "",
              };
            });

          if (this.banner.length < 2) {
            this.swiperBannerOption = {};

            this.showBanner = false;
            this.$nextTick(() => {
              this.showBanner = true;
            });
          }
          this.showBanner = false;
          this.$nextTick(() => {
            this.showBanner = true;
          });
        })
        .catch((err) => {
          console.log(err);
        });

      getNewsTabList()
        .then((res) => {
          this.tabs = res.data.list
            .map((v, index) => {
              if (index === 0) {
                this.tabId = v.id + "";
              }
              this.initNewLists(v.id);
              return { name: v.lang[this.$i18n.locale], id: v.id };
            })
            .slice(0, 1);
        })
        .catch((err) => {
          console.log(err);
        });

      getSocialList()
        .then((res) => {
          this.playLists = res.data.list;
        })
        .catch((err) => {
          console.log(err);
        });

      getIp()
        .then((res) => {
        console.log(res);
        
          // 美国ip有独立的美国包
          this.appStoreLink =
            res.data === "usa"
              ? "https://apps.apple.com/us/app/pppoker-usa-holdem-omaha/id1554633611"
              : "https://apps.apple.com/in/app/pppoker-nlh-plo-ofc/id1101622978";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initNewLists(id) {
      id = "" + id;
      getNewsList({ newsTabId: id })
        .then((res) => {
          // if (!this.tabId) {
          //   this.tabId = id
          // }

          const channelTypeMap = {
            1: "cardplayer",
            2: "poker_blog",
            3: "pokernews",
            4: "super_poker",
            5: "yahoo",
          };
          this.tabLists[id] = res.data.list
            .map((v) => {
              if (!this.pcImage) {
                this.pcImage = v.pcImage;
              }
              if (!this.pcJumpUrl) {
                this.pcJumpUrl = v.jumpUrl;
              }
              if (!this.newId) {
                this.newId = v.id;
              }

              return {
                id: v.id,
                pcImage: v.pcImage,
                jumpUrl: v.jumpUrl,
                title: v.lang[this.$i18n.locale],
                release_date: v.release_date,
                from_channel: v.from_channel
                  ? channelTypeMap[v.from_channel]
                  : "",
              };
            })
            .slice(0, 6);

          if (this.tabId === id) {
            this.showtab = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeNew(item) {
      this.newId = item.id;
      this.pcImage = item.pcImage;
      this.pcJumpUrl = item.jumpUrl;
    },
    toPlay(e) {
      this.swiper.autoplay.stop();
      e.target.parentNode.parentNode.querySelector("#player").play();
      this.no_video_play = false;
    },
    toPause() {
      // document.querySelector('#player').pause()
      document.querySelectorAll("#player").forEach((e) => {
        e.pause();
      });
      this.no_video_play = true;
    },
    toBury(key, f1, f2, f3, f4, f5) {
      this.$gtag.event(key, {
        event_category: "download",
        event_label: "button",
        value: 1,
      });
      this.$axios.get(
        "https://client-click-v2.cn-hongkong.log.aliyuncs.com/logstores/client-logstroe/track",
        {
          params: {
            APIVersion: "0.6.0",
            __topic__: key,
            f1,
            f2,
            f3,
            f4,
            f5,
            log_type: 10001,
          },
        }
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@-webkit-keyframes loader-02 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loader-02 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@-webkit-keyframes arrow {
  0% {
    -webkit-transform: translateX(0) translateY(0);
    transform: translateX(0) translateY(0);
  }
  100% {
    -webkit-transform: translateX(10px) translateY(0);
    transform: translateX(10px) translateY(0);
  }
}
@keyframes arrow {
  0% {
    -webkit-transform: translateX(0) translateY(0);
    transform: translateX(0) translateY(0);
  }
  100% {
    -webkit-transform: translateX(10px) translateY(0);
    transform: translateX(10px) translateY(0);
  }
}

.home {
  position: relative;
  padding: 0px 0px 0px 0px;
  // background-color: #000;
  .banner {
    position: relative;
    height: 771px;
    // z-index: 1;
    .slider-img {
      height: 771px;
    }
    .banner_img {
      display: block;
      width: 100%;
      height: 771px;
      background-position: center top;
      background-repeat: no-repeat;
      background-size: auto 100%;
    }
    /deep/.el-carousel__arrow {
      font-size: 30px;
    }
    /deep/.swiper-container {
      z-index: inherit;
    }
    .swiper-button-prev {
      background: url("/official/static/img/home/arrow_l.png") no-repeat center
        center;
      padding: 20px;
      background-size: 32px;
      -webkit-animation: 0.8s linear infinite alternate arrow;
      animation: 0.8s linear infinite alternate arrow;
    }
    .swiper-button-next {
      background: url("/official/static/img/home/arrow_r.png") no-repeat center
        center;
      padding: 20px;
      background-size: 32px;
      -webkit-animation: 0.8s linear infinite alternate arrow;
      animation: 0.8s linear infinite alternate arrow;
    }
    .swiper-pagination {
      bottom: 50px;
      z-index: 5;
      /deep/.swiper-pagination-bullet {
        width: 46px;
        border-radius: 0px;
        margin: 0 10px;
      }
      /deep/.swiper-pagination-bullet-active {
        background: #1f9d56;
      }
    }
    .video_play {
      background: url("/official/static/img/home/toplay.png") no-repeat center
        center;
      .circle {
        -webkit-animation: 1s loader-02 linear infinite;
        animation: 1s loader-02 linear infinite;
      }
    }
    .video_pause {
      background: url("/official/static/img/home/tostop.png") no-repeat center
        center;
    }
    .video_play,
    .video_pause {
      position: absolute;
      width: 102px;
      height: 102px;
      left: 50%;
      top: 50%;
      margin-left: -51px;
      margin-top: -51px;
      z-index: 5;
      cursor: pointer;
    }
  }
  .top {
    position: relative;
    z-index: 2;
    background-color: #f4f4f4;
    padding-bottom: 160px;
    .t_download {
      position: relative;
      margin: 0 auto;
      top: -150px;
      width: 900px;
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        display: inline-block;
        margin: 0 10px;
      }
      a img {
        -o-transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
        transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
      }
      a:hover img {
        -webkit-transform: scale(1.1);
        -ms-transform: scale(1.1);
        transform: scale(1.1);
      }
    }
    .tab_title {
      font-size: 28px;
      color: #1f9d56;
      font-weight: bold;
      height: 51px;
      // border-bottom: 1px solid #828282;
      margin-top: -15px;
      .tab_li {
        list-style: none;
        padding: 0;
        li {
          float: left;
          text-align: center;
          line-height: 48px;
          height: 48px;
          padding: 0px 12px 3px 12px;
        }
        .hightab {
          padding-bottom: 0px;
          // border-bottom: 3px solid #1f9d56;
          a {
            color: #1f9d56;
          }
        }
      }
      a {
        color: #828282;
        display: inline-block;
        cursor: default;
      }

      .el-divider--vertical:last-child {
        display: none;
      }
    }
    .top_tab {
      position: relative;
      margin: 0 auto;
      top: 10px;
      width: 1160px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .tab-image {
        position: relative;
        display: block;
        width: 669px;
        padding: 0px;
        margin: 0px;
        .jumpUrl {
          display: block;
          color: #828282;
          width: 100%;
          background-color: #ffffff;
          overflow: hidden;
          img {
            display: block;
            cursor: pointer;
          }
          .jump_cont {
            position: relative;
            background-color: #ffffff;
            padding: 4px 22px;
            height: 101px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            .jump_p {
              text-overflow: ellipsis;
              color: #272727;
              font-size: 16px;
              line-height: 22px;
              cursor: pointer;
              &:hover {
                color: #1f9d56;
              }
            }
            .jump_release {
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              span {
                color: #7d7d7d;
                font-size: 14px;
                line-height: 14px;
                margin-bottom: -1px;
              }
            }
          }
        }

        .jumpUrl .image {
          -o-transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
          transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
          -webkit-transform: scale(1);
          -ms-transform: scale(1);
          transform: scale(1);
        }
        .jumpUrl .image:hover {
          -webkit-transform: scale(1.05);
          -ms-transform: scale(1.05);
          transform: scale(1.05);
        }
      }
      .tab_cont {
        width: 472px;
        margin-left: 10px;

        .el-divider--horizontal {
          margin: 0px 0px 15px 0px;
        }
        .el-divider {
          background-color: #828282;
        }
        .tab_p {
          .jumpUrl {
            display: flex;
            color: #828282;
            line-height: 30px;
            font-size: 16px;
            width: 472px;
            background-color: #ffffff;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 11px;
            overflow: hidden;
            .image {
              cursor: pointer;
            }
            .jump_cont {
              position: relative;
              background-color: #ffffff;
              width: 297px;
              height: 84px;
              padding: 3px 9px;
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              .jump_p {
                text-overflow: ellipsis;
                color: #272727;
                font-size: 16px;
                line-height: 22px;
                cursor: pointer;
                &:hover {
                  color: #1f9d56;
                }
              }
              .jump_release {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                span {
                  color: #7d7d7d;
                  font-size: 14px;
                  line-height: 14px;
                  margin-bottom: -1px;
                }
              }
            }
          }
          .jumpUrl .image {
            -o-transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
            transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
            -webkit-transform: scale(1);
            -ms-transform: scale(1);
            transform: scale(1);
          }
          .jumpUrl .image:hover {
            -webkit-transform: scale(1.05);
            -ms-transform: scale(1.05);
            transform: scale(1.05);
          }
          .jumpUrl.highlight {
            color: #1f9d56;
          }
        }
      }
    }
  }
  .middle {
    position: relative;
    z-index: 3;
    margin-top: -150px;
    height: 1149px;
    width: 100%;
    background: url("/official/static/img/home/bg_b_01.png") center top;
    background-repeat: no-repeat;
    overflow-x: hidden;
    padding-top: 100px;
    .center {
      font-size: 30px;
      color: #fff;
      margin-top: 66px;
    }
    .swiper-slide {
      width: 310px;
      display: inline-block;
    }
    .swiper-button-prev {
      background: url("/official/static/img/home/arrow_l.png") center center;
      background-size: 100%;
    }
    .swiper-button-next {
      background: url("/official/static/img/home/arrow_r.png") center center;
      background-size: 100%;
    }
    .m-slide-image {
      position: relative;
      display: inline-block;
      width: 289px;
      height: 289px;
      margin: 10px;
      overflow: hidden;
      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
      .image-bottom {
        position: absolute;
        width: 100%;
        height: 36px;
        text-align: center;
        bottom: 0px;
        left: 0px;
        background-color: rgba(0, 0, 0, 0.75);
        p {
          font-size: 16px;
          line-height: 36px;
        }
      }
      .image-bottom {
        -o-transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
        transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
      }
    }
    .m-slide-image img {
      -o-transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
      transition: all cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
      -webkit-transform: scale(1);
      -ms-transform: scale(1);
      transform: scale(1);
    }
    .m-slide-image:hover img {
      -webkit-transform: scale(1.05);
      -ms-transform: scale(1.05);
      transform: scale(1.05);
    }
    .m-slide-image:hover .image-bottom {
      // background-color: #1f9d56;
      color: #1f9d56;
    }
    .middle_icon {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 30px;
      text-align: center;
      span {
        color: #fff;
        font-size: 20px;
        vertical-align: middle;
      }
      a {
        margin: 0 15px;
        display: inline-block;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center center;
        width: 16px;
        height: 32px;
      }
      .facebook-img {
        width: 28px;
        background-image: url(/official/static/img/home/2_facebook_w.svg);
        &:hover {
          background-image: url(/official/static/img/home/1_facebook_g.svg);
        }
      }
      .instagram-img {
        width: 28px;
        background-image: url(/official/static/img/home/2_ins_w.svg);
        &:hover {
          background-image: url(/official/static/img/home/1_ins_g.svg);
        }
      }
      .youtube-img {
        width: 28px;
        background-image: url(/official/static/img/home/2_youtube_w.svg);
        &:hover {
          background-image: url(/official/static/img/home/1_youtube_g.svg);
        }
      }
      .twitter-img {
        width: 28px;
        background-image: url(/official/static/img/home/2_twitter_w.svg);
        &:hover {
          background-image: url(/official/static/img/home/1_twitter_g.svg);
        }
      }
    }
  }
  .club {
    position: relative;
    padding: 0px 0px 0px 0px;
    overflow-x: hidden;

    .club_bg1,
    .club_bg3,
    .club_bg5 {
      width: 100%;
      height: 817px;
    }
    .club_bg2 {
      width: 100%;
      height: 817px;
      background: url("/official/static/img/home/bg_02.png") no-repeat center
        top;
    }
    .club_bg4 {
      width: 100%;
      height: 817px;
      background: url("/official/static/img/home/bg_03.png") no-repeat center
        top;
    }
    .club_bg6 {
      width: 100%;
      // height: 684px;
      height: 730px;
      background: url("/official/static/img/home/bg_02.png") no-repeat center
        top;
    }
    .club_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 120px;
      min-height: 570px;
    }
    .club_item_l {
      position: relative;
      display: inline-block;
      width: 590px;
    }
    .club_item_r {
      width: 590px;
      display: inline-block;
    }

    .title {
      font-size: 30px;
      margin: 0px;
      color: #1f9d56;
    }
    .line {
      border-bottom: 1px solid #383838;
      margin: 20px 0px;
    }
    img {
      width: 100%;
    }
    .chip_img {
      display: inline-block;
      vertical-align: middle;
      width: 16px;
      height: 16px;
      margin-bottom: 4px;
    }
    .more a {
      position: relative;
      font-size: 20px;
      color: #1f9d56;
      box-shadow: 0 1px;
      // text-decoration: underline;
      display: inline-block;
      margin-top: 10px;
      // margin-bottom: 80px;
    }
    p {
      color: #9d9d9d;
      // font-size: 24px;
      margin: 0px;
      line-height: 28px;
    }
    .c_p_title {
      font-size: 22px;
      // font-weight: 400;
      // color: #9d9d9d;
      margin-bottom: 10px;
      color: #727272;
      font-weight: normal;
    }

    @keyframes slideInLeft {
      from {
        transform: translate3d(-100%, 0, 0);
        visibility: visible;
      }

      to {
        transform: translate3d(0, 0, 0);
      }
    }
    @keyframes slideInRight {
      from {
        transform: translate3d(100%, 0, 0);
        visibility: visible;
      }

      to {
        transform: translate3d(0, 0, 0);
      }
    }
    .animal1 {
      width: 570px;
      height: 570px;
      background: url("/official/static/img/home/picture_01.jpg");
      background-repeat: no-repeat;
      animation: slideInRight;
      animation-duration: 1s;
    }
    .animal2 {
      width: 583px;
      height: 585px;
      background: url("/official/static/img/home/picture_02.jpg");
      background-repeat: no-repeat;
      animation: slideInLeft;
      animation-duration: 1s;
    }
    .animal3 {
      width: 570px;
      height: 578px;
      background: url("/official/static/img/home/picture_03.jpg");
      background-repeat: no-repeat;
      animation: slideInRight;
      animation-duration: 1s;
    }
    .animal4 {
      width: 570px;
      height: 570px;
      background: url("/official/static/img/home/picture_04.jpg");
      background-repeat: no-repeat;
      animation: slideInLeft;
      animation-duration: 1s;
    }
    .animal5 {
      width: 570px;
      height: 574px;
      background: url("/official/static/img/home/picture_05.jpg");
      background-repeat: no-repeat;
      animation: slideInRight;
      animation-duration: 1s;
    }
    .animal6 {
      width: 570px;
      height: 570px;
      background: url("/official/static/img/home/picture_06.jpg");
      background-repeat: no-repeat;
      animation: slideInLeft;
      animation-duration: 1s;
    }
  }
}
.float_button {
  position: fixed;
  height: 85px;
  right: 5px;
  bottom: 105px;
  z-index: 4;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  a {
    display: inline-block;
    background-size: 80%;
    background-repeat: no-repeat;
    background-position: center center;
    background-color: #aaa;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .facebook-img {
    background-image: url(/official/static/img/home/2_facebook_w.svg);
    &:hover {
      background-image: url(/official/static/img/home/2_facebook_g.svg);
    }
  }
  .instagram-img {
    background-image: url(/official/static/img/home/2_ins_w.svg);
    &:hover {
      background-image: url(/official/static/img/home/2_ins_g.svg);
    }
  }
  .youtube-img {
    background-image: url(/official/static/img/home/2_youtube_w.svg);
    &:hover {
      background-image: url(/official/static/img/home/2_youtube_g.svg);
    }
  }
  .twitter-img {
    background-image: url(/official/static/img/home/2_twitter_w.svg);
    &:hover {
      background-image: url(/official/static/img/home/2_twitter_g.svg);
    }
  }
}
.bottom_container {
  width: 100%;
  margin-top: 20px;
  position: absolute;
  bottom: 20px;

  .join_title {
    font-size: 30px;
    color: #1f9d56;
    font-weight: bold;
  }
}
@media only screen and (max-width: 1460px) {
  .home {
    .banner {
      height: 600px;
      .banner_img {
        height: 600px;
      }
      .slider-img {
        height: 600px;
      }
    }
  }
}
</style>
